import { Box, Inline, xcss } from '@atlaskit/primitives';
import { type FieldValueTypes } from '@databases/connections-api/slice';
import React, { type FunctionComponent } from 'react';

import EllipsisOverflow from '../common/EllipsisOverflow.tsx';

interface PageStatusProps {
  status: Extract<FieldValueTypes, { type: 'pageStatus' }>['value'];
  hasBottomMargin?: boolean;
}

const DotStyles = xcss({
  borderRadius: 'radius.full',
  minWidth: '12px',
  height: '12px',
  marginRight: 'space.075'
});

const ContainerStyles = xcss({
  display: 'inline-flex',
  backgroundColor: 'color.background.neutral',
  color: 'color.text',
  borderRadius: 'radius.small',
  paddingBlock: 'space.025',
  paddingInline: 'space.100',
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  marginBottom: 'space.050'
});

const NoBottomMarginStyles = xcss({
  marginBottom: 'space.0'
});

const PageStatus: FunctionComponent<PageStatusProps> = ({
  status,
  hasBottomMargin = true
}) => {
  return (
    <Inline
      as="div"
      alignBlock="center"
      xcss={[ContainerStyles, hasBottomMargin ? undefined : NoBottomMarginStyles]}
    >
      <Box
        xcss={[
          xcss({
            // @ts-ignore - xcss doesn't support custom color values
            backgroundColor: status.color
          }),
          DotStyles
        ]}
      />
      <EllipsisOverflow>{status.text}</EllipsisOverflow>
    </Inline>
  );
};

export default PageStatus;
